import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions } from 'react-redux-form';

import { CustomDropdown } from '../../../../../common/custom-form/custom-dropdown.component';
import { InputFieldFloatingLabel as InputField } from '../../../../../common/custom-form/select-filter.component';
import { withRouter } from 'react-router-dom';
import { RechargeInventoryDetailsActions } from '../../../../../../store/external/recharge-reducer/recharge-inventory-details.reducer/recharge-inventory-details.reducer';
import CustomSearchableDropdownWrapper from '../../../../../common/custom-form/custom-dropdown/custom-searchable-dropdown-wrapper';

class LocationInformation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isCollapsed: false,
            selectedLocationOption: [],
            locationOptions: []
        };
    }

    async componentDidMount() {
        const { rechargeInventoryDetails, rechargeInventoryDetailsForm, getLocationOption } = this.props;
        const { locationInformation } = rechargeInventoryDetailsForm;
        if (locationInformation?.locationCode) {
            await getLocationOption(1, locationInformation.locationCode);
        }
            this.setState({
                locationOptions: rechargeInventoryDetails.locationOptions,
                selectedLocationOption: rechargeInventoryDetails.locationOptions
            });

    }

    componentDidUpdate(prevProps) {
        const { rechargeInventoryDetails } = this.props;

        if (
            rechargeInventoryDetails.locationOptions !==
            prevProps.rechargeInventoryDetails.locationOptions
        ) {
            this.setState(
                { locationOptions: rechargeInventoryDetails.locationOptions }
            );
        }
    }
    handleToggle = () => {
        const { selectedLocationOption } = this.state;
        const toggledState = !this.state.isCollapsed;

        this.setState({
            isCollapsed: toggledState,
            locationOptions: selectedLocationOption?.length ? selectedLocationOption : this.state.locationOptions
        });
    };

    onChangeLocationSelection = (e) => {
        const { getLocationDetails, rechargeInventoryDetails } = this.props;

        if (e != null) {
            this.setState({
                selectedLocationOption: rechargeInventoryDetails.locationOptions
            });
            getLocationDetails(e);
        }
    };

    handleLocationSearch = (searchString) => {
        const { rechargeInventoryDetails } = this.props;

        this.props.getLocationOption(1, searchString)
        this.setState({
            locationOptions: rechargeInventoryDetails.locationOptions
        });
    }

    loadMoreLocation = (searchString) => {
        const { rechargeInventoryDetails } = this.props;

        const { locationPage } = this.props.rechargeInventoryDetails;

        this.props.getLocationOption(locationPage + 1, searchString);
        this.setState({
            locationOptions: rechargeInventoryDetails.locationOptions
        });
    }

    render() {
        const { isCollapsed, locationOptions } = this.state;
        const { translator, rechargeInventoryDetails, rechargeInventoryDetailsForm } = this.props;

        return (
            <div className="control-container">

                <CustomDropdown activeDropdown={isCollapsed} toggleActiveState={this.handleToggle} label={translator("location_information", false)} >
                    <div className={`add-sim-container detail-page-container details-4-col-container capital-uppercase`}>
                        <CustomSearchableDropdownWrapper
                            label={`${translator('location_id')}`}
                            options={locationOptions}
                            selected={rechargeInventoryDetailsForm.locationInformation.locationId}
                            onChange={(e) => this.onChangeLocationSelection(e)}
                            requiredField
                            fieldProp='rechargeInventoryDetailsForm.locationInformation.locationId'
                            optionLabelKey={{
                                Key: 'Key',
                                Value: 'Value'
                            }}
                            placeholder={`${translator('select_placeholder', false)}`}
                            onSearchChange={this.handleLocationSearch}
                            onLoadMore={this.loadMoreLocation}
                            isLoading={rechargeInventoryDetails.isLocationLoading}
                            hasMore={rechargeInventoryDetails.hasMoreLocation}
                        />
                        <InputField
                            className="form-control"
                            type="text"
                            label={translator('location_address')}
                            value={rechargeInventoryDetailsForm.locationInformation.locationId !== 0 ? rechargeInventoryDetailsForm.locationInformation.locationAddress : ""}
                            fieldProp='field'
                            disabled={true}
                        />
                        <InputField
                            className="form-control"
                            type="text"
                            label={translator('location_country_code')}
                            value={rechargeInventoryDetailsForm.locationInformation.locationId !== 0 ? rechargeInventoryDetailsForm.locationInformation.locationCountryCode : ""}
                            fieldProp='field'
                            disabled={true}

                        />
                        <InputField
                            className="form-control"
                            type="text"
                            label={translator('location_state')}
                            value={rechargeInventoryDetailsForm.locationInformation.locationId !== 0 ? rechargeInventoryDetailsForm.locationInformation.locationState : ""}
                            fieldProp='field'
                            disabled={true}

                        />
                        <InputField
                            className="form-control"
                            type="text"
                            label={translator('location_code')}
                            value={rechargeInventoryDetailsForm.locationInformation.locationId !== 0 ? rechargeInventoryDetailsForm.locationInformation.locationCode : ""}
                            fieldProp='field'
                            disabled={true}
                        />

                    </div>
                </CustomDropdown>
            </div>
        );
    }
}

export default withRouter(
    connect(
        (state) => {
            const { rechargeInventoryDetails, translation } = state;
            const { rechargeInventoryDetailsForm, forms: { rechargeInventoryDetailsForm: { $form } } } = state.form;
            return {
                ...translation,
                rechargeInventoryDetails,
                rechargeInventoryDetailsForm,
                $form
            };
        },
        (dispatch) => ({
            ...bindActionCreators(
                Object.assign({}, RechargeInventoryDetailsActions),
                dispatch
            ),
            FormChange: (model, value) => {
                dispatch(actions.change(model, value));
            },
            FormLoad: (model, data) => {
                dispatch(actions.load(model, data));
            }
        })
    )(LocationInformation));